module.exports = __webpack_public_path__ + "img/energy_icon6.fc3a0799.png";